<script lang="ts">
	import Checkbox from "./Checkbox.svelte";
	import translations from "./EmailMarketingCheckbox.translations.json";
	import { getTranslate } from "../../utils/getTranslate.js";

	const translate = getTranslate(translations);

	let formControlClass = "";
	export { formControlClass as class };
	export let emailMarketingApprovedAt: string | undefined = undefined;

	let input: HTMLInputElement | null = null;

	$: {
		if (input) {
			input.checked = Boolean(emailMarketingApprovedAt);
		}
	}

	function checkedTerms(event: Event): void {
		const input = event.target as HTMLInputElement;
		emailMarketingApprovedAt = input.checked ? new Date().toISOString() : undefined;
	}
</script>

<div class="relative">
	<Checkbox
		bind:input
		id="emailMarketingApproved"
		name=""
		on:change={checkedTerms}
		class={formControlClass}
		labelProps={{ class: "!text-xs lg:!text-base uppercase font-bahnschrift font-bold tracking-wider" }}
	>
		{translate("agree")}
	</Checkbox>
	<input type="hidden" name="emailMarketingApprovedAt" value={emailMarketingApprovedAt ?? ""} />
</div>
